export default function fbq(...args) {
  if (typeof window.fbq !== 'function') {
    return;
  }

  return window.fbq(...args);
}
